/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AcceptVisitRequestResponseUpdatedVisit } from './AcceptVisitRequestResponseUpdatedVisit';
import {
    AcceptVisitRequestResponseUpdatedVisitFromJSON,
    AcceptVisitRequestResponseUpdatedVisitFromJSONTyped,
    AcceptVisitRequestResponseUpdatedVisitToJSON,
} from './AcceptVisitRequestResponseUpdatedVisit';

/**
 * Response after marking a visit as expired.
 * @export
 * @interface MarkVisitAsExpiredResponse
 */
export interface MarkVisitAsExpiredResponse {
    /**
     * 
     * @type {string}
     * @memberof MarkVisitAsExpiredResponse
     */
    status: string;
    /**
     * 
     * @type {AcceptVisitRequestResponseUpdatedVisit}
     * @memberof MarkVisitAsExpiredResponse
     */
    updatedVisit?: AcceptVisitRequestResponseUpdatedVisit;
    /**
     * 
     * @type {Error}
     * @memberof MarkVisitAsExpiredResponse
     */
    error?: Error;
}

/**
 * Check if a given object implements the MarkVisitAsExpiredResponse interface.
 */
export function instanceOfMarkVisitAsExpiredResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function MarkVisitAsExpiredResponseFromJSON(json: any): MarkVisitAsExpiredResponse {
    return MarkVisitAsExpiredResponseFromJSONTyped(json, false);
}

export function MarkVisitAsExpiredResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkVisitAsExpiredResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'updatedVisit': !exists(json, 'updated_visit') ? undefined : AcceptVisitRequestResponseUpdatedVisitFromJSON(json['updated_visit']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MarkVisitAsExpiredResponseToJSON(value?: MarkVisitAsExpiredResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'updated_visit': AcceptVisitRequestResponseUpdatedVisitToJSON(value.updatedVisit),
        'error': value.error,
    };
}

